

interface String {
  BlankToNull(): string;
}

String.prototype.BlankToNull = function () {
  return this == "" ? null : this;
};



interface Array<T> {
  groupBy<K>(keyGetter: (input: T) => K): Map<K, Array<T>>;
  groupByToMap<K>(keyGetter: (input: T) => K): Map<K, Array<T>>;
}



